import React from 'react'
import strings from '../../lang/strings'
import {formatNumber} from '../../helper/common'
import { FORMAT } from '../../config/const'

export default function ItemPoint(props) {
  const {info} = props
  const labels = [strings.supply, strings.charge, strings.supply, strings.use, strings.die, strings.refund]
  const day_labels = [strings.supply_date, strings.pay_date, strings.supply_date, strings.use_date, strings.die_date, strings.refund_date]
  const pay_method_labels = [strings.trans, strings.phone1, strings.bank]
  const pay_status_labels = [strings.requesting, strings.pay_complete, strings.progressing, strings.refunded]
  const pay_status_classes = ['badge-progress', 'badge-complete', 'badge-progress', 'badge-cancel']
  return (
    <div className={'point-item-area pv-12'}>
      <div className={'d-flex align-items-center'}>
        <div className='charge_badge f-b fs-14 d-center'>{labels[info.po_type - 1]}</div>
        <div className='fs-22 color-0a3962 f-sb ml-20 flex-full'>{formatNumber(info.po_val) + strings._p}</div>
        <div className='sm-none d-flex align-items-center'>
          <div className='d-flex align-items-center d-point-item'>
            <div className='fs-12 sm-fs-10 color-9e9e9e'>{day_labels[info.po_type - 1]}</div>
            <div className='fs-12 sm-fs-10 f-m color-4c4c4d ml-6'>{info.po_createdat.dateFormat(FORMAT.DATE_TIME2)}</div>
          </div>
          <div className={'v-div mh-8 ' + (info.pay_info ? '' : 'invisible')} />
          <div className={'d-flex align-items-center d-point-item ' + (info.pay_info ? '' : 'invisible')}>
            <div className='fs-12 sm-fs-10 color-9e9e9e'>{strings.pay_amount}</div>
            <div className='fs-12 sm-fs-10 f-m color-4c4c4d ml-6'>{formatNumber(info.pay_info ? info.pay_info.pay_amount : 0) + strings.won}</div>
          </div>
          <div className={'v-div mh-8 ' + (info.pay_info ? '' : 'invisible')} />
          <div className={'d-flex align-items-center d-point-item ' + (info.pay_info ? '' : 'invisible')}>
            <div className='fs-12 sm-fs-10 color-9e9e9e'>{strings.pay_method}</div>
            <div className='fs-12 sm-fs-10 f-m color-4c4c4d ml-6 mr-8'>{info.pay_info ? pay_method_labels[info.pay_info.pay_method - 1] : ''}</div>
          </div>
        </div>
        <div className={'fs-12 f-sb d-center ' + (info.pay_info ? (info.pay_info.pay_status < 9 ? pay_status_classes[info.pay_info.pay_status] : 'badge-cancel') : 'invisible')}>{info.pay_info ? (info.pay_info.pay_status < 9 ? pay_status_labels[info.pay_info.pay_status] : strings.pay_cancel) : ''}</div>
      </div>
      <div className='align-items-center sm-point-info sm-mt-14'>
        <div className='fs-12 color-9e9e9e'>{day_labels[info.po_type - 1]}</div>
        <div className='fs-12 f-m color-4c4c4d ml-6 flex-full'>{info.po_createdat.dateFormat(FORMAT.DATE_TIME2)}</div>
        <div className={'v-div mr-6 ' + (info.pay_info ? '' : 'invisible')} />
        <div className={'fs-12 color-9e9e9e ' + (info.pay_info ? '' : 'invisible')}>{strings.pay_amount}</div>
        <div className={'fs-12 f-m color-4c4c4d ml-6 flex-full ' + (info.pay_info ? '' : 'invisible')}>{formatNumber(info.pay_info ? info.pay_info.pay_amount : 0) + strings.won}</div>
        <div className={'v-div mr-6 ' + (info.pay_info ? '' : 'invisible')} />
        <div className={'fs-12 color-9e9e9e ' + (info.pay_info ? '' : 'invisible')}>{strings.pay_method}</div>
        <div className={'fs-12 f-m color-4c4c4d ml-6 ' + (info.pay_info ? '' : 'invisible')}>{info.pay_info ? pay_method_labels[info.pay_info.pay_method - 1] : ''}</div>
      </div>
    </div>
  )
}

